import $ from 'jquery'
import { PluginObject } from 'Vue'

export default <PluginObject<{}>>{
	install(Vue, options) {
		Vue.prototype.$toast = function (options: SemanticUI.Toast.Options) {
			$(document.body).toast(options)
		}
	},
}
